<div class="white">

  <div class="box-header">
    <h3 *ngIf="!hideTitle">{{'EMPLOYEE_MANAGE.attachments' | translate}}</h3>
  </div>

  <div class="box-body">
    <table *ngIf="loading || attachments.length > 0" class="table table-striped gp-table"
           [class.table-hover]="!loading" [attr.aria-busy]="loading"
           [attr.aria-label]="'EMPLOYEE_MANAGE.attachments' | translate">
      <thead gp-table-head>
      <tr role="row">
        <th width="50"></th>
        <th class="text-left column-title text-muted" gp-table-column>
          {{ 'EMPLOYEE_MANAGE.file_name' | translate }}
        </th>
        <th class="text-left column-title text-muted" gp-table-column>
          {{ 'EMPLOYEE_MANAGE.file_tag' | translate }}
        </th>
        <th class="text-left column-title text-muted" gp-table-column>
          {{ 'EMPLOYEE_MANAGE.last_modified' | translate }}
        </th>
        <th gp-table-column width="50"></th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngIf="loading">
        <tr *ngFor="let row of [0, 1, 2, 3, 4]" class="attachment-skeleton-row" aria-hidden="true">
          <td width="50">
            <skeleton-block width="18px" height="18px" effect="wave" borderRadius="4"></skeleton-block>
          </td>
          <td>
            <skeleton-block [width]="row % 2 === 0 ? '70%' : '50%'" height="16px" effect="wave" borderRadius="4"></skeleton-block>
          </td>
          <td width="170">
            <skeleton-block width="75%" height="16px" effect="wave" borderRadius="4"></skeleton-block>
          </td>
          <td width="175">
            <skeleton-block width="85%" height="16px" effect="wave" borderRadius="4"></skeleton-block>
          </td>
          <td width="150">
            <skeleton-block width="60%" height="24px" effect="wave" borderRadius="4"></skeleton-block>
          </td>
        </tr>
      </ng-container>
      <ng-container *ngFor="let folder of attachments">
        <tr>
          <td width="50">
            <i aria-hidden="true" class="fa fa-light fa-folder pointer"
               [class.fa-folder-open]="folder.expanded"
               (click)="toggleGroupZone(folder)"></i>
          </td>
          <td class="text-left">
            <span class="folder-title" (click)="toggleGroupZone(folder)">{{ folder.groupZone | translate }}</span>
          </td>
          <td class="text-left" width="170"></td>
          <td width="175" class="text-left">{{ folder.updateDate | gpDate:{withTime: true} }}</td>
          <td width="150"></td>
        </tr>
        <ng-container *ngIf="folder.expanded">
          <tr *ngFor="let file of folder.files">
            <td width="50" class="text-right">
              <i aria-hidden="true" class="fa fa-light" [ngClass]="getFileIcon(file)"></i>
            </td>
            <td class="text-left">
              <span class="text-ellipsis w-550">{{ file.filename }}</span>
            </td>
            <td class="text-left">{{ file.zone | translate }}</td>
            <td class="text-left w-170">{{ file.updateDate | gpDate:{withTime: true} }}</td>
            <td class="text-left w-150">
              <ng-template #detailsPopover>
                <div style="width: 400px;">
                  <div class="row">
                    <div class="col-xs-6 text-muted">{{ 'EMPLOYEE_MANAGE.file_name' | translate }}</div>
                    <div class="col-xs-6">{{file.filename}}</div>
                  </div>
                  <div class="row">
                    <div class="col-xs-6 text-muted">{{ 'EMPLOYEE_MANAGE.file_type' | translate }}</div>
                    <div class="col-xs-6">{{file.filename.split('.').last().toUpperCase()}}</div>
                  </div>
                  <div class="row">
                    <div class="col-xs-6 text-muted">{{ 'EMPLOYEE_MANAGE.file_size' | translate }}</div>
                    <div class="col-xs-6">{{file.size | gpByte}}</div>
                  </div>
                  <div class="row">
                    <div class="col-xs-6 text-muted">{{ 'EMPLOYEE_MANAGE.folder_name' | translate }}</div>
                    <div class="col-xs-6">{{file.groupZone | translate}}</div>
                  </div>
                  <div class="row">
                    <div class="col-xs-6 text-muted">{{ 'EMPLOYEE_MANAGE.file_tag' | translate }}</div>
                    <div class="col-xs-6">{{file.zone | translate}}</div>
                  </div>
                  <div class="row">
                    <div class="col-xs-6 text-muted">{{ 'EMPLOYEE_MANAGE.uploaded' | translate }}</div>
                    <div class="col-xs-6">{{file.uploadDate | gpDate:{withTime: true} }}</div>
                  </div>
                  <div class="row">
                    <div class="col-xs-6 text-muted">{{ 'EMPLOYEE_MANAGE.last_modified' | translate }}</div>
                    <div class="col-xs-6">{{ file.updateDate | gpDate:{withTime: true} }}</div>
                  </div>
                  <div class="row">
                    <div class="col-xs-6 text-muted">{{ 'EMPLOYEE_MANAGE.owner' | translate }}</div>
                    <div class="col-xs-6">{{file.initiatorName}}</div>
                  </div>
                </div>
              </ng-template>
              <div class="actions nowrap">
                <button class="btn btn-sm btn-icon white"
                        *ngIf="isViewAttachmentsActive() && isSupportedFileType(file.filename)"
                        [tooltip]="'TOOLTIPS.view' | translate"
                        (click)="viewFile($event, file)">
                  <i aria-hidden="true" class="fa fa-light fa-eye"></i>
                </button>

                <button class="btn btn-sm btn-icon white"
                        [popover]="detailsPopover"
                        [popoverTitle]="'EMPLOYEE_MANAGE.details' | translate"
                        triggers="mouseenter:mouseleave"
                        container="body"
                        placement="left">
                  <i aria-hidden="true" class="fa fa-light fa-file-circle-info"></i>
                </button>

                <button class="btn btn-sm btn-icon white"
                        [tooltip]="'EMPLOYEE_MANAGE.download' | translate"
                        *ngIf="!file.downloading"
                        (click)="downloadFile(file)">
                  <i aria-hidden="true" class="fa fa-light fa-download"></i>
                </button>
                <i aria-hidden="true" *ngIf="file.downloading" class="fa fa-light fa-spinner fa-spin m-x-xs"></i>

                <ng-container *ngIf="!isReadOnly && !file.readOnly">
                  <button class="btn btn-sm btn-icon white"
                          [tooltip]="'EMPLOYEE_MANAGE.change_name' | translate"
                          (click)="onRenameFile(file)">
                    <i aria-hidden="true" class="fa fa-light fa-edit"></i>
                  </button>

                  <button class="btn btn-sm btn-icon white"
                          [tooltip]="'EMPLOYEE_MANAGE.remove' | translate"
                          (click)="removeFile(file, folder)">
                    <i aria-hidden="true" class="fa fa-light fa-trash-alt"></i>
                  </button>
                </ng-container>
              </div>
            </td>
          </tr>
        </ng-container>
      </ng-container>
      </tbody>
    </table>
    <div *ngIf="!loading && attachments.length === 0" class="p-y-lg">
      <gp-illustrated-message type="NO_CONTENT" text="EMPLOYEE_MANAGE.attachments_not_found" width="280px"></gp-illustrated-message>
    </div>
  </div>

</div>

<gp-modal #renameModal
          gp-modal="renameFile"
          [onSubmit]="renameCallback"
          [submitEnabled]="isFileNameValid"
          [closable]="true"
          size="xs">
  <div class="gp-modal-title">
    <h4>{{'EMPLOYEE_MANAGE.change_name' | translate}}</h4>
  </div>
  <div class="gp-modal-body">
    <!--<div class="row ro">-->
    <!--<div class="col-xs-10">-->
    <div class="form-group">
      <label>{{ 'EMPLOYEE_MANAGE.file_name' | translate }} (.{{selectedFile?.filename.split('.').last()}})</label>
      <input type="text" class="form-control" [formControl]="renameFileControl">
      <ul class="error-list"
          [attr.data-hidden]="renameFileControl.valid || renameFileControl.pristine">
      </ul>
    </div>
    <!--</div>-->
    <!--<div class="col-xs-2 text-left v-b">-->
    <!--.xls-->
    <!--</div>-->
    <!--</div>-->

  </div>
</gp-modal>

<gp-view-document-side-panel
  *ngIf="showViewDocumentPanel"
  (close)="onCloseSidePanel()"
  [currentFileName]="currentFileName"
  [error]="previewError"
  [noSupportedFormat]="noSupportedFormat"
  [loading]="loadingPreview"
  [preview]="reportDefinitionPreview"
></gp-view-document-side-panel>
